var _require = require('../utils'),
    adjust = _require.adjust,
    gradient = _require.gradient;

var favicon = require('./favicons/rml/favicon-32x32.png');

var PRIMARY = '#008eb3';
var SECONDARY = '#fbad17';
var TERTIARY = '#cb1334';
var GHOST = '#008eb3';
var GHOST_SECONDARY = '#cb1334';
var GHOST_TERTIARY = '#fbad17';
var FILLED = '#00597c';
var NEUTRAL = '#d1d6da';
var DANGER = '#cb1334';
var DARK = '#404040';
var LIGHT = '#e2e2e2';
var FONT = 'Arial, Helvetica, sans-serif';
var MIN_HEIGHT = "500px";
export default {
  favicon: favicon,
  name: 'rml',
  logo: 'rml.jpg',
  logo_text: false,
  logo_link: false,
  logo_fineprint: false,
  minheight: 'calc(100vh - ' + MIN_HEIGHT + ')',
  google_font: '',
  font_headings: FONT,
  font_body: FONT,
  border_colour: '#D1D6DA',
  header: {
    fontSize: '15px'
  },
  font: {
    input_weight: 400
  },
  ui: {
    containerWidth: 1440,
    footerWidth: 1440,
    defaultLogoWidth: 180,
    defaultLogoHeight: 78,
    smallLogoWidth: 125,
    smallLogoHeight: 54,
    burgerWidth: 50,
    burgerHeight: 50,
    burgerVerticalBarWidth: 30,
    burgerVerticalBarHeight: 3,
    bodyBgColor: '#00597c',
    // colours.primary.darkest,
    bodyWrapperBgColor: '#ffffff'
  },
  defaultMenuItems: [{
    text: 'Get a quote',
    href: '/group-start',
    site: 'group'
  }, {
    text: 'FAQs',
    href: '/faqs',
    site: 'micro'
  }, {
    text: 'Let us call you',
    href: '/call-me',
    site: 'micro',
    type: 'button'
  }],
  domains: {
    website: 'https://www.insure.randmutual.co.za',
    group: 'https://group.insure.randmutual.co.za',
    admin: 'https://admin.insure.randmutual.co.za'
  },
  margintop: '0',
  margintopMobile: "0",
  fonts: {
    h1: {
      desktop: 'bold 2.5rem ' + FONT,
      mobile: 'bold 2.25rem ' + FONT
    },
    h2: {
      desktop: 'bold 2rem ' + FONT,
      mobile: 'bold 1.75rem ' + FONT
    },
    h3: {
      desktop: 'bold 1.75rem ' + FONT,
      mobile: 'bold 1.5rem ' + FONT
    },
    h4: {
      desktop: 'bold 1.5rem ' + FONT,
      mobile: 'bold 1.25rem ' + FONT
    },
    h5: {
      desktop: 'bold 1.5rem ' + FONT,
      mobile: 'bold 1.25rem ' + FONT
    },
    h6: {
      desktop: 'bold 1rem ' + FONT,
      mobile: 'bold 0.85rem ' + FONT
    },
    p: {
      desktop: '1rem -apple-system,BlinkMacSystemFont, ' + FONT,
      mobile: '1rem -apple-system,BlinkMacSystemFont,' + FONT
    },
    li: {
      desktop: '1rem/1.7rem -apple-system,BlinkMacSystemFont,' + FONT,
      mobile: '1rem/1.7rem -apple-system,BlinkMacSystemFont,' + FONT
    }
  },
  colours: {
    darkest: adjust(DARK, -10),
    darker: adjust(DARK, -5),
    dark: DARK,
    light: LIGHT,
    lighter: adjust(LIGHT, 5),
    lightest: adjust(LIGHT, 10),
    primary: {
      darkest: '#00597c',
      darker: '#008eb3',
      dark: '#01587f',
      base: PRIMARY,
      light: adjust(PRIMARY, 10),
      lighter: adjust(PRIMARY, 20),
      lightest: adjust(PRIMARY, 30),
      light_text: adjust(PRIMARY, 50),
      dark_text: adjust(PRIMARY, -50),
      border_colour: 'transparent',
      gradient: gradient(45, adjust(PRIMARY, -15), PRIMARY),
      gradient_hover: gradient(45, adjust(PRIMARY, -25), adjust(PRIMARY, 10))
    },
    secondary: {
      darkest: adjust(SECONDARY, -30),
      darker: adjust(SECONDARY, -20),
      dark: adjust(SECONDARY, -10),
      base: SECONDARY,
      light: adjust(SECONDARY, 10),
      lighter: adjust(SECONDARY, 20),
      lightest: adjust(SECONDARY, 30),
      light_text: adjust(SECONDARY, 50),
      dark_text: adjust(SECONDARY, -50),
      border_colour: 'transparent',
      gradient: gradient(45, adjust(SECONDARY, -15), SECONDARY),
      gradient_hover: gradient(45, adjust(SECONDARY, -25), adjust(SECONDARY, 10))
    },
    tertiary: {
      darkest: adjust(TERTIARY, -30),
      darker: adjust(TERTIARY, -20),
      dark: adjust(TERTIARY, -10),
      base: TERTIARY,
      light: adjust(TERTIARY, 10),
      lighter: adjust(TERTIARY, 20),
      lightest: adjust(TERTIARY, 30),
      light_text: adjust(TERTIARY, 50),
      dark_text: adjust(TERTIARY, -50),
      border_colour: 'transparent',
      gradient: gradient(45, adjust(TERTIARY, -15), TERTIARY),
      gradient_hover: gradient(45, adjust(TERTIARY, -25), adjust(TERTIARY, 10))
    },
    ghost: {
      darkest: 'transparent',
      darker: 'transparent',
      dark: 'transparent',
      base: 'transparent',
      light: 'transparent',
      lighter: 'transparent',
      lightest: 'transparent',
      light_text: adjust(GHOST, 50),
      dark_text: adjust(GHOST, -50),
      border_colour: GHOST,
      gradient: 'none',
      gradient_hover: 'none'
    },
    'ghost-secondary': {
      darkest: 'transparent',
      darker: 'transparent',
      dark: 'transparent',
      base: 'transparent',
      light: 'transparent',
      lighter: 'transparent',
      lightest: 'transparent',
      light_text: adjust(GHOST_SECONDARY, 50),
      dark_text: adjust(GHOST_SECONDARY, -50),
      border_colour: GHOST,
      gradient: 'none',
      gradient_hover: 'none'
    },
    'ghost-tertiary': {
      darkest: 'transparent',
      darker: 'transparent',
      dark: 'transparent',
      base: 'transparent',
      light: 'transparent',
      lighter: 'transparent',
      lightest: 'transparent',
      light_text: adjust(GHOST_TERTIARY, 50),
      dark_text: adjust(GHOST_TERTIARY, -50),
      border_colour: GHOST_TERTIARY,
      gradient: 'none',
      gradient_hover: 'none'
    },
    filled: {
      darkest: '#ffffff',
      darker: '#ffffff',
      dark: '#ffffff',
      base: '#ffffff',
      light: '#ffffff',
      lighter: '#ffffff',
      lightest: '#ffffff',
      light_text: adjust(FILLED, 50),
      dark_text: adjust(FILLED, -50),
      border_colour: FILLED,
      gradient: 'none',
      gradient_hover: 'none'
    },
    neutral: {
      darkest: adjust(NEUTRAL, -50),
      darker: adjust(NEUTRAL, -20),
      dark: adjust(NEUTRAL, -10),
      base: NEUTRAL,
      light: adjust(NEUTRAL, 5),
      lighter: adjust(NEUTRAL, 10),
      lightest: adjust(NEUTRAL, 20),
      light_text: adjust(NEUTRAL, 30),
      dark_text: adjust(NEUTRAL, -30),
      border_colour: 'transparent',
      gradient: gradient(45, adjust(NEUTRAL, -15), NEUTRAL),
      gradient_hover: gradient(45, adjust(NEUTRAL, -25), adjust(NEUTRAL, 10))
    },
    danger: {
      darkest: adjust(DANGER, -30),
      darker: adjust(DANGER, -20),
      dark: adjust(DANGER, -10),
      base: DANGER,
      light: adjust(DANGER, 10),
      lighter: adjust(DANGER, 20),
      lightest: adjust(DANGER, 30),
      light_text: adjust(DANGER, 50),
      dark_text: adjust(DANGER, -50),
      border_colour: 'transparent',
      gradient: gradient(45, adjust(DANGER, -15), DANGER),
      gradient_hover: gradient(45, adjust(DANGER, -25), adjust(DANGER, 10))
    }
  }
};